import { render } from "./EnrolleeBulkOnboardComponent.vue?vue&type=template&id=6fe0d3f5&scoped=true"
import script from "./EnrolleeBulkOnboardComponent.vue?vue&type=script&lang=js"
export * from "./EnrolleeBulkOnboardComponent.vue?vue&type=script&lang=js"

import "./EnrolleeBulkOnboardComponent.vue?vue&type=style&index=0&id=6fe0d3f5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fe0d3f5"]])

export default __exports__